import Typography from '@material-ui/core/Typography';
import Button from '@mui/material/Button';
import clsx from 'clsx';
import Modal from 'components/atoms/Modal';
import { memo } from 'react';
import { isMobile } from 'react-device-detect';
import styles from './style.module.css';

const CustomModal = memo(function CustomModal({
  icon = true,
  children,
  onClose,
  onClickOk,
  visible,
  className,
  restProps,
  title,
  content,
  isWelcomeBack,
  showClose = true,
  showOK = true,
  btnOk = 'Có',
  btnOnClose = 'Không',
  btnCloseRender = (
    <Button variant="contained" className={`${styles.defaultBtn} ${styles.font_gg}`} onClick={onClose} data-test="btn-custom-modal-cancel">
      {btnOnClose}
    </Button>
  ),
  btnOkRender = (
    <Button variant="contained" className={styles.font_gg} onClick={onClickOk} color="success" data-test="btn-custom-modal-ok">
      {btnOk}
    </Button>
  ),
  customBtnRender,
}) {
  return (
    <Modal className={className} open={visible} {...restProps} onClose={onClose}>
      <div
        className={clsx(
          styles.confirm_modal_wrap,
          isWelcomeBack && isMobile ? styles.confirm_modal_wrap_welcomeBackMobile : styles.confirm_modal_wrap_welcomeBack,
          isWelcomeBack ? styles.slide_up_animation : '',
        )}
      >
        <div style={{ textAlign: 'center' }}>
          {icon &&
            (isWelcomeBack ? (
              <span className={isMobile ? styles.size_icon_welcomeBackMobile : styles.size_icon_welcomeBack}>🎉</span>
            ) : (
              <div className={styles.warning_icon}>
                <Typography className={styles.text_icon}>!</Typography>
              </div>
            ))}
          {title && (
            <Typography className={styles.modal_title} data-test="modal-custom-title">
              {title}
            </Typography>
          )}
          {content && (
            <Typography className={styles.modal_content} data-test="modal-custom-content">
              {content}
            </Typography>
          )}
          {children}
        </div>
        <div style={{ marginTop: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5em' }}>
          {showClose && !!btnCloseRender && btnCloseRender}
          {showOK &&!!btnOkRender && btnOkRender}
          {!!customBtnRender && customBtnRender}
        </div>
      </div>
    </Modal>
  );
});

export default CustomModal;
